import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=2a1b025f&"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports